var _defs, _path, _path2, _g, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e5e5e5;}.cls-3{fill:#fff;fill-rule:evenodd;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.88,
    y: 3.89,
    width: 32.23,
    height: 32.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.28,35.87a15.89,15.89,0,0,1-5.9-2.26l-6,1.19,1.18-5.9a16.12,16.12,0,1,1,10.71,7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -602.34,
    y1: 39.5,
    x2: -602.31,
    y2: 39.5,
    gradientTransform: "matrix(669.42, 1338.85, 1338.85, -669.42, 350351.11, 832881.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58d265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#58d265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#58d265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#58d265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#57d264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#57d164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#56d164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#56d163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#55d063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#55d062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#54d062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#53cf62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#53cf61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#52cf61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#52ce60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#51ce60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#51ce5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#50cd5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#50cd5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4fcd5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4fcd5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4ecc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4ecc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4dcc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ccb5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4ccb5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4bcb5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4bca5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4aca5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4aca5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#49c95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#49c959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#48c959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#48c858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#47c858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#46c858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#46c757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#45c757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#45c756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#44c756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#44c655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#43c655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#43c655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#42c554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#42c554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#41c553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#41c453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#40c452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3fc452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3fc352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3ec351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3ec351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3dc250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#3dc250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3cc250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3cc14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#3bc14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3bc14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3ac14e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3ac04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#39c04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#38c04d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#38bf4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#37bf4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#37bf4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#36be4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#36be4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#35be4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#35bd4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#34bd49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#34bd49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#33bc48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#32bc48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#32bc48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#31bb47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#31bb47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#30bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#30bb46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2fba46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2fba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2eba45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2eb944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2db944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2db943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2cb843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2bb843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2bb842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2ab742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2ab741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#29b741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#29b641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#28b640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28b640"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,39.5a19.54,19.54,0,0,1-9.25-2.33L1.09,39.1,3,29.55a19.5,19.5,0,1,1,17,10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.79,6.21A19.5,19.5,0,0,0,3,29.55L1.09,39.1l9.66-1.93a19.5,19.5,0,0,0,23-31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.77-11.48-10.6,9.2,10.06,50.53,51.44,29.84Z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.35,22.88a3.31,3.31,0,0,0-2.84-.64c-.74.3-1.21,1.45-1.69,2a.71.71,0,0,1-.92.2A12.84,12.84,0,0,1,15.48,19a.79.79,0,0,1,.1-1.08A4.4,4.4,0,0,0,16.75,16a4.12,4.12,0,0,0-.53-2.24,5.27,5.27,0,0,0-1.65-2.5,2.28,2.28,0,0,0-2.47.37,5,5,0,0,0-1.73,4,6,6,0,0,0,.16,1.26,10.36,10.36,0,0,0,1.2,2.78A22.5,22.5,0,0,0,13,21.55a19.26,19.26,0,0,0,5.46,5.07,16.14,16.14,0,0,0,3.41,1.62,7.63,7.63,0,0,0,4,.63,4.8,4.8,0,0,0,3.59-2.67,2.32,2.32,0,0,0,.17-1.37c-.21-.94-1.48-1.5-2.24-1.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.cfefc11f601bdbecae62d16d99d61020.svg";
export { ForwardRef as ReactComponent };